import { AgrupamentoTalhao__Item } from "../../../../../../../services/monitoramento/agrupamentoTalhao/GET";
import { MultiCoordinates } from "../../../../../../CustomUi/talhaoSvgAgrupado";
import { MonitoramentoMapCalorType } from "../../../../../novo-index";


export function obterAgrupamentos(main_data: { [key: string]: MonitoramentoMapCalorType[] }, data_agrupamentos: AgrupamentoTalhao__Item[]) {

    let monitoramento = (Object.entries(main_data)).map(([cod_talhao, dados_monitoramento]) => {
        return {
            cod_talhao: Number(cod_talhao),
            dados_monitoramento: dados_monitoramento
        }
    })

    let agrupamentos = data_agrupamentos?.map((item) => {
        let talhoes = (item?.talhao ?? []).map((talhao_info) => {
            return {
                nome_talhao: talhao_info?.talhao_nome,
                cod_talhao: talhao_info?.cod_talhao,
                coordenadas_talhao: talhao_info?.talhao_kml?.coordenadas,
                monitoramento_talhao: (monitoramento ?? []).find((monito) => monito.cod_talhao === talhao_info?.cod_talhao) ?? null
            }
        })
        return {
            nome_agrupamento: item.nome,
            cod_agrupamento: item.cod,
            talhoes_agrupamento: talhoes
        }
    });

    return agrupamentos ?? [];
};

type Coordenadas = {
    nome_talhao: string;
    cod_talhao: number;
    coordenadas_talhao: {
        latitude: number | null;
        longitude: number | null;
    }[];
    monitoramento_talhao: {
        cod_talhao: number;
        dados_monitoramento: MonitoramentoMapCalorType[];
    };
}

export function mesclarCoordenadasDoAgrupamento(coordenadas: Coordenadas[]) {

    let apenas_coordenadas = coordenadas.map(({ coordenadas_talhao }) => {
        let renomear_keys = coordenadas_talhao.map(({ latitude, longitude }) => {
            return {
                lat: latitude,
                lng: longitude
            }
        })
        return renomear_keys
    })

    //@ts-ignore
    let mesclar_coordenadas = apenas_coordenadas.flat();

    return mesclar_coordenadas ?? []
}

/**Retorna uma array de arrays contendo as coordenadas do talhão */
export function obterCoordenadasAgrupadas(coordenadas: Coordenadas[]): MultiCoordinates {

    let estrutura: MultiCoordinates = coordenadas.map(({ coordenadas_talhao }) => {
        return coordenadas_talhao
    })

    return estrutura ?? []
};

export function obterCoordenadasMapDeCalor(coordenadas: Coordenadas[]) {

    let estrutura = coordenadas.map(({ coordenadas_talhao }) => {
        return coordenadas_talhao.map((item) => {
            return [item.latitude, item.longitude]
        })
    });

    let estrutura_com_ligacao = [...estrutura];

    // Pegando um ponto de cada polígono para criar a ligação
    let ligacao = estrutura.map(polygon => polygon[0]);

    // Adicionando a ligação ao array principal
    estrutura_com_ligacao.push(ligacao);

    //@ts-ignore 
    return estrutura_com_ligacao.flat() ?? [];
}